import axios from 'axios'

const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone

const ventasApi = axios.create({
  baseURL: import.meta.env.VENTAS_BASE_URL,
  timeout: 1000 * 60 * 0.8,
  withCredentials: true,
})

ventasApi.interceptors.request.use((config) => {
  config.headers['X-Timezone'] = userTimezone
  return config
})

export { ventasApi }
